import UserProfileAvatar from "./UserProfileAvatar";

export default UserProfileAvatar;
